import { defineComponent as _defineComponent } from 'vue'
import type { TooltipOptions } from 'bootstrap';
import $ from 'jquery';
import {
    nextTick,
    onMounted, onUnmounted, onUpdated, unref,
} from 'vue';
import { Fragment } from 'vue-fragment';

import { useGenerateIds } from '#public_ts/composables';

import { typeSafeObjectKeys } from '../commons';


export default /*#__PURE__*/_defineComponent({
  __name: 'tool-tip',
  props: {
    id: { default: undefined },
    animation: { type: Boolean, default: undefined },
    container: { type: [String, Boolean], default: undefined },
    delay: { default: undefined },
    placement: { default: undefined },
    title: { default: undefined },
    trigger: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { id: string, animation: boolean, container: 'body' | string | false, delay: TooltipOptions['delay'], placement: TooltipOptions['placement'], title: TooltipOptions['title'], trigger: TooltipOptions['trigger'] }

const generateIds = useGenerateIds();


const controlId = props.id || generateIds();
let currentElement: HTMLElement | undefined;

function updateToolTip() {
    if(currentElement) {
        destroyToolTip();
    }
    const $el = $(`#${unref(controlId)}`);
    if($el.length > 0) {
        const options = {
            animation: props.animation,
            container: props.container,
            delay: props.delay,
            placement: props.placement,
            title: props.title,
            trigger: props.trigger,
        };
        typeSafeObjectKeys(options).forEach((key) => {
            if(options[key] === undefined) {
                delete options[key];
            }
        });
        $el.tooltip(options);
        currentElement = $el[0];
    }
}

function destroyToolTip() {
    if(currentElement) {
        try {
            $(currentElement).tooltip('destroy');
        } catch(err) { /**/ }
        currentElement = undefined;
    }
}

onMounted(() => {
    //portal requires nextTick
    nextTick(() => {
        nextTick(() => {
            updateToolTip();
        });
    });
});
onUnmounted(destroyToolTip);
onUpdated(updateToolTip);

return { __sfc: true,generateIds, props, controlId, currentElement, updateToolTip, destroyToolTip, Fragment }
}

})